<!--
  AI:
  Status: "confirmed"
  Type: Component
  SubType: CrudIntegration
  Reason: ObjectBaseComponent template for LogicFlowExecution entity — status/mode badges and generic CRUD form.
-->

@if (initialized && dto) {
    <div class="p-3">
        <div class="flex align-items-center gap-2 mb-3">
            <p-tag [value]="statusLabel" [severity]="statusSeverity"></p-tag>
            <p-tag [value]="modeLabel" severity="info"></p-tag>
            @if (durationMs) {
                <span class="text-sm text-color-secondary">
                    <i class="fa-regular fa-clock mr-1"></i>{{ durationMs }}ms
                </span>
            }
        </div>

        <!-- AI: CRUD Object Component for LogicFlowExecution editing -->
        <mvs-crud-object
            [objectType]="'lg.LogicFlowExecution'"
            [objectId]="objectIdentifier.objectId"
            (onChangedObject)="refreshObject(false)">
        </mvs-crud-object>
    </div>
}
